import {
	Component,
	OnInit,
	Input,
	ComponentFactoryResolver,
	ViewContainerRef,
	ComponentRef,
	ViewChild,
	Output,
	EventEmitter,
	HostBinding,
	Optional,
	OnDestroy,
} from "@angular/core";
import { CTAButtonContext, CTAButtonLayoutContext } from "./cta-button.models";
import { CtaButtonLayoutIconTitleComponent } from "../cta-button--layouts/cta-button-layout-icon-title/cta-button-layout-icon-title.component";
import { CtaButtonLayoutSubtitleNotePriceComponent } from "../cta-button--layouts/cta-button-layout-subtitle-note-price/cta-button-layout-subtitle-note-price.component";
import { CtaButtonLayoutInternetDataComponent } from "../cta-button--layouts/cta-button-layout-internet-data/cta-button-layout-internet-data.component";
import { CTAButtonLayout } from "../cta-button--layouts/cta-button-layout";
import { CtaButtonGroupComponent } from "../cta-button-group/cta-button-group.component";

const components = {
	IconTitleContext: CtaButtonLayoutIconTitleComponent,
	SubtitleNotePriceContext: CtaButtonLayoutSubtitleNotePriceComponent,
	TitleNotePriceContext: CtaButtonLayoutInternetDataComponent,
};

@Component({
    selector: "dodo-cta-button",
    templateUrl: "./cta-button.component.html",
    styleUrls: ["./cta-button.component.scss"],
    standalone: false
})
export class CtaButtonComponent implements OnInit, OnDestroy {
	@Input() id: string | number;
	@Input() isRadio: boolean;
	@Input() isCheckBox: boolean;
	@Input() layoutContext: CTAButtonLayoutContext;

	@HostBinding("class.active")
	__active: boolean;

	__selected: boolean;

	@Input() set active(val: boolean) {
		console.log("activating button : ", this.id, val);
		this.__active = val;
	}

	@Input() set selected(val: boolean) {
		console.log("activating button : ", this.id, val);
		this.__selected = val;
		if (val) {
			this._clicked();
		}
	}

	@HostBinding("class.disabled")
	@Input()
	disabled: boolean;

	@Input()
	tags: string[];

	@Input()
	promoDescription: string;

	@Input()
	titleBelowButton: string;

	@Input()
	buttonBelowFeatures: string[];

	@Input() set context(ctx: CTAButtonContext<CTAButtonLayoutContext>) {
		this.id = this.id || ctx.id;
		this.tags = this.tags || ctx.tags;
		this.promoDescription = this.promoDescription || ctx.promoDescription;
		this.layoutContext = this.layoutContext || ctx.layoutContext;
	}

	@Output() clicked = new EventEmitter<string | number>();

	@ViewChild("componentContainer", { static: true, read: ViewContainerRef })
	componentContainer: ViewContainerRef;

	_component: ComponentRef<CTAButtonLayout>;

	constructor(
		private __resolver: ComponentFactoryResolver,
		@Optional() private __ctaButtonGroup: CtaButtonGroupComponent
	) {}

	ngOnInit() {
		if (this.layoutContext) {
			if (this.layoutContext.type) {
				const componentClass = components[this.layoutContext.type];
				if (componentClass) {
					const factory = this.__resolver.resolveComponentFactory<
						CTAButtonLayout
					>(componentClass);
					this._component = this.componentContainer.createComponent(
						factory
					);
					this._component.instance.layoutContext = this.layoutContext;
				}
			}
		}

		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.addButton(this);
		}

		console.log("activating button init before activate: ", this.id);
		if (this.__selected) {
			console.log("activating button init within activate: ", this.id);
			this._clicked();
		}
	}

	ngOnDestroy() {
		if (this.__ctaButtonGroup) {
			this.__ctaButtonGroup.removeButton(this);
		}
	}

	_clicked() {
		this.clicked.emit(this.id);
	}
}
